module.exports = __webpack_public_path__ + "Roboto-LightItalic.879d940bccbb25f6096e.woff2";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-LightItalic.woff2
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-LightItalic.woff2
// module chunks = styles